/* eslint-disable no-use-before-define */
import React from 'react'
import { setLastLoc, publish, trackView, Views } from '../twd'
import Faq from '../faq'
import Overview from '../overview'
import Corporates from '../corporates'
import Municipals from '../municipals'
import Orders from '../orders'
import OrderTicket from '../order-ticket'
import OrdersConfirm from '../orders/confirm'
import Offerings from '../offerings'
import SavedSearches from '../saved-searches'
import AdvancedScreener from '../advanced-screener'
import PortfolioReport from '../portfolio-report'
import SellYourBond from '../sell-your-bond'
import ToolsAndResources from '../tools-and-resources'
import Tools from '../tools-and-resources/tools'
import TreasuryAuctions from '../treasury-auctions'
import BondDetail from '../bond-detail'

export default ({view, args={}} = {}) => {
    return <ErrorBoundary>
        <Content view={view} args={args} />
    </ErrorBoundary>
}

const titles = {
    overview: 'Overview - Bond Resource Center - E*TRADE',
    corporates: 'Corporates - Bond Resource Center - E*TRADE',
    municipals: 'Municipals - Bond Resource Center - E*TRADE',
    'advanced-screener': 'Advanced Screener - Bond Resource Center - E*TRADE',
    'sell-your-bond': 'Sell Your Bond - Bond Resource Center - E*TRADE',
    'bond-detail': 'Bond Detail - Bond Resource Center - E*TRADE',
    'offerings': 'Search Results - Bond Resource Center - E*TRADE',
    'orders': 'View Orders - Bond Resource Center - E*TRADE',
    'orders-confirm': 'Order - Bond Resource Center - E*TRADE',
    'order-ticket': 'Place a Trade - Bond Resource Center - E*TRADE',
    'tools': 'Tools and Resources - Bond Resource Center - E*TRADE',
    'tools-and-resources': 'Tools and Resources - Bond Resource Center - E*TRADE',
    'tools.bond-order': 'Bond Order - Bond Resource Center - E*TRADE',
    'portfolio-report': 'Portfolio Report - Bond Resource Center - E*TRADE',
    'treasury-auctions': 'Treasury Auctions - Bond Resource Center - E*TRADE',
    'faq': 'Frequently Asked Questions - Bond Resource Center - E*TRADE',
}

const Content = ({view, args={}} = {}) => {
    args = args || {}

    if (view==='bond-detail') {
        if (args.last) {
            args.from = (Views.history[Views.index] || [])[0] || ''
            delete args.last
        }
        if (!args.cusip) {
            view='overview'
        }
    }

    view = view === 'search-results'
        ? 'advanced-screener'
        : view

    if (TRACKABLE_LOCATIONS.indexOf(args.view || view)>=0) {
        setLastLoc(args)
    }

    React.useEffect(() => {
        trackView(view, args)

        document.title = titles[args.view || view ] || 'Bond Resource Center - E*TRADE'
    }, [view, args])


    return <div id="content" style={{ minHeight:'150px' }}>{
        view==='overview' ? <Overview {...args} /> :
        view==='corporates' ? <Corporates {...args} /> :
        view==='municipals' ? <Municipals {...args} /> :
        view==='advanced-screener' ? <AdvancedScreener {...args} /> :
        view==='sell-your-bond' ? <SellYourBond {...args} /> :
        view==='tools-and-resources' ? <ToolsAndResources {...args} /> :
        view==='bond-detail' ? <BondDetail {...args} /> :

        view==='offerings' ? <Offerings {...args} /> :
        view==='orders' ? <Orders {...args} /> :
        view==='order-ticket' ? <OrderTicket {...args} /> :
        view==='orders-confirm' ? <OrdersConfirm {...args} /> :
        view==='portfolio-report' ? <PortfolioReport {...args} /> :
        view==='saved-searches' ? <SavedSearches {...args} /> :
        view==='treasury-auctions' ? <TreasuryAuctions {...args} /> :
        view==='tools' ? <Tools {...args} /> :
        view==='tools.bond-order' ? <Tools {...args} /> :
        view==='faq' ? <Faq {...args} /> :
        <Overview {...args} />
    }</div>
}

const TRACKABLE_LOCATIONS = [
    'overview',
    'corporates',
    'municipals',
    'advanced-screener',
    'tools-and-resources',
    'offerings',
    'orders',
    'portfolio-report',
    'treasury-auctions',
    'tools',
    'faq'
]

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError:false }
    }
    static getDerivedStateFromError(error) {
        return {hasError:true}
    }
    componentDidCatch(error) {
        console.log('ERROR', error)
    }
    render() {
        if (this.state.hasError) {
            // eslint-disable-next-line
            this.state.hasError = false

            setTimeout(() => publish('error-boundary'))
            return <Content view="" />
        }
        return this.props.children
    }
}


// WEBPACK FOOTER //
// ./src/App/content.js